import React from 'react';
import { palette } from '../theme';

interface IconPillProps {
  selected?: boolean;
  onClick?: () => void;
  children: React.ReactNode;
}

export const IconPill: React.FC<IconPillProps> = ({ selected, onClick, children }) => (
  <div
    onClick={onClick}
    style={{
      padding: 8,
      borderRadius: 8,
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      boxSizing: 'border-box',
      cursor: onClick ? 'pointer' : undefined,
      backgroundColor: selected ? palette.primitives.purple.purple50 : 'transparent',
      color: selected ? palette.primitives.purple.purple400 : palette.primitives.grey.grey300,
      transition: 'background-color 120ms ease, color 120ms ease'
    }}
  >
    {children}
  </div>
);
